<div class="container">
  <yf-card-preview [number]="$preview().number" [owner]="$preview().owner" [expiryMonth]="$preview().expiryMonth"
    [expiryYear]="$preview().expiryYear" [cvv]="$preview().securityCode" [flipped]="$cvvFocused()"></yf-card-preview>

  <form [formGroup]="form" (focusin)="onFieldFocusIn($event)" (focusout)="onFieldFocusOut()">
    <formly-form [model]="model" [fields]="fields" [form]="form" [options]="options"></formly-form>
  </form>
  <div class="cvv-help">
    <a href="https://www.cvvnumber.com/cvv.html" target="_blank">{{
      "CDC_AUTHENTICATION.WHAT_IS_CVV_CODE" | translate }}</a>
  </div>

  @if($footerVisible()){
  <ion-footer class="ion-no-border yf-footer">
    <div class="yf-row gap-6">
      <ion-button class="btn large grow" fill="outline" (click)="options.resetModel()">{{ "BUTTONS.CANCEL" | translate
        }}</ion-button>
      <ion-button class="btn large grow" (click)="submit()" [disabled]="!form.valid">{{
        "CDC_AUTHENTICATION.BUTTONS.CHECK_CARD_VALIDITY" | translate }}</ion-button>
    </div>
  </ion-footer>
  }
</div>
